// extracted by mini-css-extract-plugin
export default {"cls1":"sJejcRvr8HF0TNX2AZ_n","cls2":"HKovcTrfFmzpWfaYjvJ8 sJejcRvr8HF0TNX2AZ_n"};